import React, { Component } from "react";
import { Row, Col } from 'react-bootstrap';
import Table from "react-bootstrap/Table";
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from '../../../../../common/translation/translation.component';
import Icons from '../../../../../icon';
import { YES_OR_NO } from '../../../../../../utils/constant.utils';
import { ORDER_STATUS } from '../../../../../../constants/external-constants';
import { convertToDecimal } from '../../../../../../utils/helpers.utils';

export class NewMobileSubscriptionDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    editRequest = (orderStatusId, endUserId, requestorId) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);

        return editableRequest && isRequestOwner;
    }

    displayAccessories = (accessories, currency) => {

    return accessories != null && accessories.length != 0
        ? accessories.map((item, i) => (
            
            <tr key={i}>
                <td>{i == 0 ? <Translation translationKey="accessory" /> : null}</td>
                <td>
                    <Row>
                    <Col xs={6} md={6} lg={6} className="request-details-sec-val">
                        {item.EquipmentModel}
                    </Col>
                    <Col xs={6} md={6} lg={6} className="request-details-sec-val">
                        {currency} {item.OrderCost.toFixed(2)}
                    </Col>
                    </Row>
                </td>
            </tr>
        ))
        : null;
    }

    displayPlanComponents = props => {
        const { PlanComponents } = this.props.data.Subscription.PlanDetails;
        return PlanComponents != null && PlanComponents.length != 0
            ? PlanComponents.map((item, i) => (
                <tr key={i}>
                    <td>{i === 0 ? <Translation translationKey="plan_component" /> : null}</td>
                    <td>{item.ComponentName}</td>
                </tr>
            ))
            : null;
    };

    render() {
        const {  status, data, isWireline, openRequestModal } = this.props;
        const {Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId }} = data || {};
        const totalOrderCost =  data.Subscription.DiscountedOrderCost !== null ?  convertToDecimal(data.Subscription.DiscountedOrderCost + data.Subscription.TotalCost) : data.Subscription.TotalCost;
        const discountedOrderCost = data.Subscription.DiscountedOrderCost !== null ? convertToDecimal(data.Subscription.DiscountedOrderCost) : data.Subscription.MobileServiceModel[0].OrderCost
        return (
            <div>
                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                    {this.editRequest(OrderStatusId, EndUserId, RequestorId) ?  
                        <>
                        <Icons
                            customClassName="pen-to-square"
                            name="pen-to-square"
                            size="20px"
                            containerClass="icon-circle-plus-container"
                            onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                            labelValue={"Update Order Request"}
                            labelClass="order-detail-edit-label"                                                              
                        />
                        </>
                        : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container mb-0">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>
                    <div className="order-detail-number-container mb-0">
                        <div className="order-title">
                            <Translation translationKey="capital_sr_number" />
                        </div>
                        <div className="sr-number-label">
                            {data.Order.ServiceRequestNumber}
                        </div>
                    </div>                    
                    {data.Order.IsRequestedInBehalf ?
                        <Table className="mb-0">
                            <tbody>
                                <tr>
                                    <td className="order-detail-location-title pt-0"><RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} /></td>
                                </tr>
                            </tbody>
                        </Table>
                        : null}
                    <h5 className="order-detail-location-title mt-1"><Translation translationKey="capital_location" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="country" /></td>
                                <td>
                                    {data.OtherLocationID != null && data.OtherLocationID != 0 ? data.OtherLocationCountry : data.Location.CountryName}
                                </td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="delivery_address" /></td>
                                <td>
                                    {data.OtherLocationID != null && data.OtherLocationID != 0 ? data.OtherLocationName : data.Location.DeliveryAddress}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="vendor" /></td>
                                <td>{data.Subscription.Vendor}</td>
                            </tr>
                            {data.Subscription.CircuitType !== null && data.Subscription.CircuitTypeId >= 0 &&
                                <tr>
                                    <td><Translation translationKey="circuit_type" /></td>
                                    <td>{data.Subscription.CircuitType}</td>
                                </tr>
                            }
                            {data.Subscription.MobileServiceModel
                                && data.Subscription.MobileServiceModel.length > 0 ?
                                <tr>
                                    <td><Translation translationKey="mobile_service_type" /></td>
                                    <td>
                                        <Row>
                                            <Col xs={6} md={6} lg={6}>
                                                {data.Subscription.MobileServiceModel[0].EquipmentModel}
                                            </Col>
                                            <Col xs={6} md={6} lg={6}>
                                                {`${discountedOrderCost} ${data.Subscription.PlanDetails.Currency.CurrencyName}`}
                                            </Col>
                                        </Row>
                                    </td>
                                </tr> : null
                            }
                            <tr>
                                <td><Translation translationKey="accessory" /></td>
                                <td>{data.Subscription.PhoneCaseAccessory ? YES_OR_NO.Yes : YES_OR_NO.No}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="plan_name" /></td>
                                <td>{data.Subscription.PlanDetails.PlanName}</td>
                            </tr>
                            {this.displayPlanComponents(data.Subscription.PlanDetails.PlanComponents === null ? data.NewRequest.PlanDetails.PlanComponents : data.Subscription.PlanDetails.PlanComponents.slice(0, 1))}

                            {data.Subscription.MobileServiceModel
                                && data.Subscription.MobileServiceModel.length > 0 &&
                                <tr>
                                    <td><Translation translationKey="total_order_cost" /></td>
                                    <td>{totalOrderCost} {data.Subscription.PlanDetails.Currency.CurrencyName}</td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title">
                        <Translation translationKey="capital_business_justification" />
                    </h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="purpose_of_use" /></td>
                                <td>{data.BusinessJustification.PurposeOfUse}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_case" /></td>
                                <td>{data.BusinessJustification.DetailName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="term_agreement" /></td>
                                <td>{data.BusinessJustification.TermAgreement ? YES_OR_NO.Yes : YES_OR_NO.No}</td>
                            </tr>
                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}